var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noInfo",style:({ padding: _vm.padding })},[_c('div',{staticClass:"icon"},[_c('svg-sprite',{attrs:{"icon-id":"icon-info","width":"120","height":"120"}})],1),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }